module.exports = __webpack_public_path__ + "static/img/shiliaologo.51895838.png";